<div *ngIf="showSettings" smTooltip="Settings" (click)="toggleSettings.emit()">
  <i class="al-icon al-ico-settings pointer"></i>
</div>
